module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "design-svg",
    attrs: {
      "preserveAspectRatio": "xMinYMin meet",
      "viewBox": ("0 0 " + (_vm.design.width) + " " + (_vm.design.height))
    }
  }, [_c('defs', [_c('clipPath', {
    attrs: {
      "id": (_vm._uid + "-clip-path")
    }
  }, [_c('rect', {
    attrs: {
      "width": _vm.design.width,
      "height": _vm.design.height
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": ("url(#" + _vm._uid + "-clip-path)")
    }
  }, [(_vm.scalePattern) ? _vm._l((_vm.scalePattern), function(layer) {
    return _c('g', _vm._l((layer), function(block) {
      return _c('g', {
        key: block.key,
        staticClass: "design-block",
        attrs: {
          "data-key": block.key
        },
        on: {
          "click": function($event) {
            _vm.$emit('block-click', {
              key: block.key,
              block: block
            })
          }
        }
      }, [_c('path', {
        attrs: {
          "transform": _vm.getBlockTransform(block),
          "d": block.path,
          "fill": _vm.getBlockFill(block)
        }
      })])
    }))
  }) : (_vm.sp402Pattern) ? _vm._l((_vm.sp402Pattern), function(block) {
    return _c('g', {
      key: block.key,
      staticClass: "design-block",
      attrs: {
        "data-key": block.key
      },
      on: {
        "click": function($event) {
          _vm.$emit('block-click', {
            key: block.key,
            block: block
          })
        }
      }
    }, [_c('path', {
      attrs: {
        "transform": _vm.getBlockTransform(block),
        "d": block.path,
        "fill": "#f5f5f5"
      }
    })])
  }) : _vm._l((Object.entries(_vm.design.data)), function(ref) {
    var key = ref[0];
    var block = ref[1];

    return _c('g', {
      key: key,
      staticClass: "design-block",
      on: {
        "click": function($event) {
          _vm.$emit('block-click', {
            key: key,
            block: block
          })
        }
      }
    }, [(_vm.brand === 'filzfelt' && block.points) ? _c('polygon', {
      attrs: {
        "points": _vm.getBlockPoints(block),
        "fill": _vm.getBlockFill(block)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.brand === 'filzfelt' && !block.points && !_vm.scaleBlockInUse) ? _c('path', {
      attrs: {
        "transform": _vm.getBlockTransform(block),
        "d": _vm.getFFBlockPath(block),
        "fill": _vm.getBlockFill(block)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.brand === 'spinneybeck') ? _c('g', {
      directives: [{
        name: "draggable",
        rawName: "v-draggable",
        value: (!_vm.readonly),
        expression: "!readonly"
      }],
      attrs: {
        "transform": ("translate(" + (block.x) + " " + (block.y) + ")"),
        "data-drag": _vm.getBlockDropData(block)
      },
      on: {
        "drag-start": function($event) {
          _vm.blockDrag(key, $event)
        },
        "drag-end": function($event) {
          _vm.blockDrop(key, $event)
        }
      }
    }, [_c('polygon', {
      attrs: {
        "points": "0,0 16,0 16,16 0,16",
        "fill": "#eacfa2"
      }
    }), _vm._v(" "), (_vm.getBlockPath(block)) ? _c('path', {
      staticClass: "sp-path",
      attrs: {
        "d": _vm.getBlockPath(block),
        "transform": ("rotate(" + (block.r || 0) + " 8 8)"),
        "fill": "none"
      }
    }) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), _c('rect', {
    staticClass: "design-border",
    attrs: {
      "width": _vm.design.width,
      "height": _vm.design.height
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb5cdc42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/DesignView.vue
// module id = 574
// module chunks = 1